import { Download, History, RotateCcw } from 'lucide-react';
import type { Nodo } from '@doc/shared';
import { fecha, tamano } from '../../lib/formato.js';
import { urlArchivo } from '../../lib/api.js';
import { Modal } from '../../ui/Modal.js';
import { useAvisos } from '../../ui/avisos.js';
import { useAcciones, useVersiones } from './consultas.js';

export function DialogoVersiones({ nodo, alCerrar }: { nodo: Nodo; alCerrar(): void }) {
  const { data, isLoading } = useVersiones(nodo.id);
  const { restaurarVersion } = useAcciones();
  const { avisar, avisarError } = useAvisos();

  async function restaurar(version: number) {
    try {
      await restaurarVersion.mutateAsync({ id: nodo.id, version });
      avisar(`Se publicó el contenido de la versión ${version} como versión nueva`);
    } catch (error) {
      avisarError(error);
    }
  }

  return (
    <Modal titulo={`Versiones de "${nodo.nombre}"`} icono={<History size={17} />} ancho alCerrar={alCerrar}>
      {isLoading && <div className="cargando">Cargando…</div>}

      {data && (
        <table className="tabla">
          <thead>
            <tr>
              <th style={{ width: 70 }}>Versión</th>
              <th>Comentario</th>
              <th style={{ width: 120 }}>Autor</th>
              <th style={{ width: 90 }}>Tamaño</th>
              <th style={{ width: 150 }}>Fecha</th>
              <th style={{ width: 110 }} />
            </tr>
          </thead>
          <tbody>
            {data.map((v) => (
              <tr key={v.id}>
                <td>
                  <span className={`badge${v.esActual ? ' badge--verde' : ''}`}>v{v.version}</span>
                </td>
                <td>{v.comentario ?? '—'}</td>
                <td className="muted">{v.creadoPorNombre ?? '—'}</td>
                <td className="muted">{tamano(v.bytes)}</td>
                <td className="muted">{fecha(v.creadoEn)}</td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <a className="btn btn--fantasma btn--icono btn--sm" href={urlArchivo(nodo.id, 'descargar', v.version)} title="Descargar esta versión">
                    <Download size={14} />
                  </a>
                  {!v.esActual && nodo.permisos.escribir && (
                    <button
                      className="btn btn--fantasma btn--icono btn--sm"
                      title="Volver a esta versión"
                      onClick={() => void restaurar(v.version)}
                      disabled={restaurarVersion.isPending}
                    >
                      <RotateCcw size={14} />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <p className="muted" style={{ fontSize: 11.5, marginTop: 14, lineHeight: 1.55 }}>
        Subir un archivo con el mismo nombre no reemplaza al anterior: publica una versión nueva. Volver a una versión
        antigua tampoco borra el historial — copia ese contenido como la versión siguiente, así queda registrado quién
        revirtió y cuándo.
      </p>
    </Modal>
  );
}
